import { isDefinedString, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";

import { SECTION_OPEN_STATES_STORAGE_KEY } from "../../../constants/core-constants";

class CoreLayoutStore {
  sectionOpenStates = observable.map<string, boolean>();

  constructor() {
    this.restoreSectionOpenStates();
  }

  restoreSectionOpenStates = () => {
    const storedStates = reduce(
      () => localStorage.getItem(SECTION_OPEN_STATES_STORAGE_KEY),
      ""
    );
    if (!isDefinedString(storedStates)) {
      return;
    }
    const parsedStates: Record<string, boolean> = reduce(
      () => JSON.parse(storedStates),
      {}
    );
    runInAction(() => {
      Object.keys(parsedStates).forEach((sectionId) => {
        this.sectionOpenStates.set(
          sectionId,
          reduce(() => parsedStates[sectionId], false)
        );
      });
    });
  };

  persistSectionOpenStates = () => {
    const statesToStore: Record<string, boolean> = {};
    this.sectionOpenStates.forEach((isOpen, sectionId) => {
      statesToStore[sectionId] = isOpen;
    });
    localStorage.setItem(
      SECTION_OPEN_STATES_STORAGE_KEY,
      JSON.stringify(statesToStore)
    );
  };

  isSectionOpen = (sectionId: string, defaultOpen: boolean) => {
    if (!this.sectionOpenStates.has(sectionId)) {
      return defaultOpen;
    }
    return reduce(() => this.sectionOpenStates.get(sectionId), defaultOpen);
  };

  toggleSection = (sectionId: string, defaultOpen: boolean) => {
    const isOpen = this.isSectionOpen(sectionId, defaultOpen);
    runInAction(() => {
      this.sectionOpenStates.set(sectionId, !isOpen);
    });
    this.persistSectionOpenStates();
  };
}

const getCoreLayoutStore = memoize(
  () => new CoreLayoutStore(),
  () => 1
);
export default getCoreLayoutStore;
